import { Component, Input, OnInit } from '@angular/core';

/**
 * Collapsible callout that points the user at a setup guide. The body is projected content:
 *
 * <app-guide-callout btnLabel="Banking Setup Guide" btnUrl="https://..." storageKey="banking-guide-expanded">
 *   <p>Guide text</p>
 * </app-guide-callout>
 */
@Component({
  selector: 'app-guide-callout',
  templateUrl: './guide-callout.component.html',
  styleUrls: ['./guide-callout.component.scss'],
})
export class GuideCalloutComponent implements OnInit {

  // text and url of the guide link in the footer
  @Input() btnLabel: string;
  @Input() btnUrl: string;

  // when false the body is always shown and the show/hide toggle is not displayed
  @Input() collapsible = true;

  // initial state of the body
  @Input() expanded = true;

  // when set, the expanded state is remembered (per browser) under this key
  @Input() storageKey: string;

  ngOnInit() {
    if (this.collapsible && this.storageKey) {
      try {
        const stored = localStorage.getItem(this.storageKey);
        if (stored != null) {
          this.expanded = stored !== 'false';
        }
      } catch {
        // storage unavailable, use the default
      }
    }
  }

  toggle() {
    this.expanded = !this.expanded;
    if (this.storageKey) {
      try {
        localStorage.setItem(this.storageKey, String(this.expanded));
      } catch {
        // storage unavailable, state just won't be remembered
      }
    }
  }
}
